import { useSelector } from '@xstate/react';
import { type SnapshotFrom } from 'xstate';

import { useLastInteractedStoreMachine } from './useLastInteractedStoreMachine';

import type { LastInteractedStoreMachineRefType } from './machine';

/**
 * Returns last interacted store slug or delivery address ID
 * based on the following order with corresponding fallbacks.
 *
 * 1. Active cart's store.
 * 2. Last opened/visited menu store.
 * 3. Last order store.
 */
export const useLastInteractedStore = () => {
  const lastInteractedStoreMachineRef = useLastInteractedStoreMachine();

  return useSelector(lastInteractedStoreMachineRef, getLastInteractedStore);
};

function getLastInteractedStore(snapshot: LastInteractedStoreSnapshot) {
  return snapshot.context.lastInteractedStore;
}

type LastInteractedStoreSnapshot = SnapshotFrom<LastInteractedStoreMachineRefType>;
